export const menuTokens = {
  menu: {
    root: {
      background: '{surface.0}',
      color: '{text.color}',
      borderColor: '{surface.300}',
      borderRadius: '{borderRadius.sm}',
      shadow: '0 0.5rem 1.25rem 0 rgba(53, 67, 88, 0.08)'
    },
    list: {
      padding: '0.5rem',
      gap: '0'
    },
    item: {
      padding: '0.5rem 0.75rem',
      borderRadius: '{borderRadius.sm}',
      color: '{text.color}',
      gap: '0.5rem',
      iconColor: '{text.color}',
      focusBackground: '{surface.300}',
      focusColor: '{text.color}',
      iconFocusColor: '{text.color}'
    }
  }
};

export const menuDarkDt = {
  root: {
    background: '{surface.1000}',
    color: '{surface.0}',
    borderColor: 'transparent',
    shadow: 'none'
  },
  item: {
    color: '{surface.300}',
    iconColor: '{surface.300}',
    focusBackground: '{surface.1100}',
    focusColor: '{surface.300}',
    iconFocusColor: '{surface.300}'
  }
};

export type MenuTokens = typeof menuTokens;
